var map = {
	"./023A3385.jpg": 204,
	"./023A3387.jpg": 4806,
	"./023A3388.jpg": 8585,
	"./023A3389.jpg": 6694,
	"./023A3391.jpg": 2619,
	"./023A3402.jpg": 7488,
	"./aboutCulinary.jpg": 3523,
	"./chairs.jpg": 1270,
	"./displayDesk.jpg": 8135,
	"./zzzzzzz.jpg": 2723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1042;